import PendingApprovalAdviserProfilesApi from '../../../../../core/api/PendingApprovalAdviserProfilesApi'

export const events = {
  edit: {
    profilePicture: {
      start: 'PENDING_APPROVAL_START_EDITING_PROFILE_PICTURE',
      stop: 'PENDING_APPROVAL_STOP_EDITING_PROFILE_PICTURE',
      cancel: 'PENDING_APPROVAL_CANCEL_EDITING_PROFILE_PICTURE'
    },
    companyPicture: {
      start: 'PENDING_APPROVAL_START_EDITING_COMPANY_PICTURE',
      stop: 'PENDING_APPROVAL_STOP_EDITING_COMPANY_PICTURE',
      cancel: 'PENDING_APPROVAL_CANCEL_EDITING_COMPANY_PICTURE'
    },
    start: 'PENDING_APPROVAL_START_EDITING_PICTURES',
    stop: 'PENDING_APPROVAL_STOP_EDITING_PICTURES'
  },
  set: {
    profilePicture: 'PENDING_APPROVAL_SET_PROFILE_PICTURE',
    companyPicture: 'PENDING_APPROVAL_SET_COMPANY_PICTURE'
  },
  upload: {
    profilePicture: {
      uploading: 'PENDING_APPROVAL_UPLOADING_PROFILE_PICTURE',
      uploaded: 'PENDING_APPROVAL_UPLOADING_PROFILE_PICTURE_COMPLETE'
    },
    companyPicture: {
      uploading: 'PENDING_APPROVAL_UPLOADING_COMPANY_PICTURE',
      uploaded: 'PENDING_APPROVAL_PENDING_APPROVAL_UPLOADING_COMPANY_PICTURE_COMPLETE'
    }
  }
}

const api = new PendingApprovalAdviserProfilesApi()
const { edit, set, upload } = events
export const actions = {
  edit: {
    profilePicture: {
      start: () => ({
        type: edit.profilePicture.start
      }),
      stop: () => ({
        type: edit.profilePicture.stop
      }),
      cancel: () => ({
        type: edit.profilePicture.cancel
      })
    },
    companyPicture: {
      start: () => ({
        type: edit.companyPicture.start
      }),
      stop: () => ({
        type: edit.companyPicture.stop
      }),
      cancel: () => ({
        type: edit.companyPicture.cancel
      })
    }
  },
  set: {
    profilePicture: (image) => ({
      type: set.profilePicture,
      image
    }),
    companyPicture: (image) => ({
      type: set.companyPicture,
      image
    })
  },
  upload: {
    profilePicture: (adviserId, profile) => {
      const request = api.updateProfilePicture(adviserId, profile)
      return (dispatch) => {
        dispatch({ type: upload.profilePicture.uploading })
        request.then(function (response) {
          dispatch(api.handleResponse(upload.profilePicture.uploaded, response))
        })
      }
    },
    companyPicture: (adviserId, profile) => {
      const request = api.updateCompanyLogo(adviserId, profile)
      return (dispatch) => {
        dispatch({ type: upload.companyPicture.uploading })
        request.then(function (response) {
          dispatch(api.handleResponse(upload.companyPicture.uploaded, response))
        })
      }
    }
  }
}
